import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Header from "./Header";
import TextField from "@mui/material/TextField";
import { fontSize, styled } from "@mui/system";
import Button from "../../common/components/Button";
import { MdOutlinePostAdd } from "react-icons/md";
import { MdPreview } from "react-icons/md";
import Dialog from "@mui/material/Dialog";
import MuiDialogContent from "@mui/material/DialogContent";
import * as APIService from "../../common/api/index.js";
import URL from "../../common/api/ConstantURL";
import { getSessionContext } from "../../common/utils/sessionContext";
import AlertMessage from "../../common/components/AlertMessage";
import Backdrop from "@mui/material/Backdrop";
import { IoChevronBackCircleSharp } from "react-icons/io5";
import * as Sentry from "@sentry/react";
const CustomTextField = styled(TextField)({
  "& label.Mui-focused": {
    color: "#FCB040",
    fontWeight: "bold",
  },
  "& .MuiInput-underline:after": {
    borderBottomColor: "#B2BAC2",
  },
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: "#FCB040",
    },
    "&:hover fieldset": {
      borderColor: "#B2BAC2",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#FCB040",
    },
    "& .MuiInputBase-input": {
      padding: "10px",
      fontSize: "14px",
    },
    "@media (max-height: 700px)": {
      "& .MuiInputBase-input": {
        fontSize: "14px",
      },
    },
  },
});

const emptyVitalForm = () => ({
  date: "",
  time: "",
  leftArmBP: "",
  rightArmBP: "",
  currentHeartRate: "",
  restingHeartRate: "",
  bodyTemp: "",
  bloodSugar: "",
  oxygenLevel: "",
  weight: "",
});

const vitalPayloadToFormState = (parsed) => {
  if (!parsed || typeof parsed !== "object") return emptyVitalForm();
  const s = (v) => (v == null ? "" : String(v));
  return {
    date: s(parsed.date),
    time: s(parsed.time),
    leftArmBP: s(parsed.leftArmBP ?? parsed.leftArmBp),
    rightArmBP: s(parsed.rightArmBP ?? parsed.rightArmBp),
    currentHeartRate: s(parsed.currentHeartRate),
    restingHeartRate: s(parsed.restingHeartRate),
    bodyTemp: s(parsed.bodyTemp),
    bloodSugar: s(parsed.bloodSugar),
    oxygenLevel: s(parsed.oxygenLevel),
    weight: s(parsed.weight),
  };
};

const Vitals = () => {
  const [showTodoPopup, setShowTodoPopup] = useState(false);
  const [loading, setLoading] = useState(false);
  const [alertStatus, setAlertStatusBase] = useState("");
  const [allVitalInfoClientList, setAllVitalInfoClientList] = useState([]);
  const [vitalData, setVitalData] = useState({
    date: "",
    time: "",
    leftArmBP: "",
    rightArmBP: "",
    currentHeartRate: "",
    restingHeartRate: "",
    bodyTemp: "",
    bloodSugar: "",
    oxygenLevel: "",
    weight: "",
  });

  const navigate = useNavigate();

  useEffect(() => {
    getAllVitalInfoByClientId();
  }, []);

  const getAllVitalInfoByClientId = () => {
    setAllVitalInfoClientList([]);
    setLoading(true);

    const { residentId } = getSessionContext();
    const clientId = residentId;
    APIService.getData(URL.getAllVitalInfoByClientId + "?clientId=" + clientId)
      .then((responseData) => {
        if (responseData.code == 200) {
          setAllVitalInfoClientList(responseData.data || []);
        } else {
          setAlertStatusBase({
            message: responseData.message,
            status: responseData.code,
            origin: "center",
          });
        }
        setLoading(false);
      })
      .catch((error) => {
        Sentry.captureException(error);
        setLoading(false);
        setAlertStatusBase({
          message: "Error while fetch vitals of the resident",
          status: "400",
          origin: "center",
        });
      });
  };

  const openTodo = (e, vitals) => {
    e.preventDefault();
    let parsed = {};
    try {
      const raw = vitals?.vitalInformation;
      parsed = typeof raw === "string" ? JSON.parse(raw) : raw || {};
    } catch (err) {
      Sentry.captureException(err);
      parsed = {};
    }
    setVitalData(vitalPayloadToFormState(parsed));
    setShowTodoPopup(true);
  };

  const handleClose = () => {
    setShowTodoPopup(false);
  };

  const closeAlert = () => {
    setAlertStatusBase("");
  };

  const handleBack = () => {
    navigate("/resident-home");
  };

  return (
    <>
      <Header />
      <div className="home-container">
        <Backdrop sx={{ color: "#ffba30", zIndex: (theme) => theme.zIndex.drawer + 1000 }} open={loading}>
          <img src={require("../../assets/btTree.png")} className="loading-img" />
        </Backdrop>
        {alertStatus ? <AlertMessage status={alertStatus.status} message={alertStatus.message} origin={alertStatus.origin} closeAlert={closeAlert} /> : null}
        <div className="home-inner-container" style={{ justifyContent: "flex-start" }}>
          <div className="heading vitals-heading">
            <IoChevronBackCircleSharp className="vitals-preview-header" onClick={handleBack} />
            <span style={{ fontWeight: "500", paddingLeft: "0px" }}>{getSessionContext().residentName}</span>
            <span></span>
          </div>
          <div className="task-container col-11 col-sm-11 col-md-8 col-lg-4 col-xl-4" style={{ overflow: "inherit", cursor: "default", padding: "0px" }}>
            <div className="title-container vitals-outer-container">
              <span className="previous">Previously Submitted Vitals</span>
              <MdOutlinePostAdd className="vitals-preview-header" onClick={() => navigate("/addVitals")} style={{ width: "17%" }} />
            </div>
            <div className="vitals-container">
              {allVitalInfoClientList.length > 0 ? (
                allVitalInfoClientList.map((vitals, index) => {
                  return (
                    <div style={{ cursor: "default" }} key={index} className="vital-data">
                      <span className="vital-date">{vitals.createdDate}</span>
                      <MdPreview className="vitals-preview" onClick={(e) => openTodo(e, vitals)} />
                    </div>
                  );
                })
              ) : (
                <div className="no-task" style={{ justifyContent: "center" }}>
                  <span> No Vitals Available </span>
                </div>
              )}
            </div>
            <Dialog
              maxWidth="lg"
              className="popup-subscriber"
              aria-labelledby="customized-dialog-title"
              open={showTodoPopup}
              style={{ padding: "16px" }}
              PaperProps={{
                style: {
                  height: "calc(100% - 25px)",
                  maxHeight: "calc(100% - 25px)",
                },
              }}>
              <div className="popup-subscriber-header" style={{ justifyContent: "center" }}>
                <div className="popup-title">VIEW VITAL INFORMATION</div>
              </div>

              <MuiDialogContent dividers className="popup-body-1" style={{ padding: "15px" }}>
                <div className="label" style={{ paddingBottom: "15px", textAlign: "center" }}>
                  {getSessionContext().residentName}
                </div>
                <div className="pop-row">
                  <div className="label col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                    Report Date & Time <span className="required">*</span>
                  </div>

                  <div className="vital-row col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                    <div className="answer col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                      <CustomTextField style={{ width: "100%" }} focused type="date" id="vital-dialog-date" label="MM/DD/YYYY" variant="outlined" name="date" value={vitalData.date} disabled InputLabelProps={{ shrink: true }} />
                    </div>

                    <div className="answer col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                      <CustomTextField style={{ width: "100%" }} focused type="time" id="vital-dialog-time" label="HH:MM" variant="outlined" name="time" value={vitalData.time} disabled InputLabelProps={{ shrink: true }} />
                    </div>
                  </div>
                </div>
                <div className="pop-row">
                  <div className="label col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">Blood Pressure</div>

                  <div className="vital-row col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                    <div className="answer col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                      <CustomTextField focused id="vital-dialog-left-bp" label="Left Arm" variant="outlined" helperText="High / Low" name="leftArmBP" value={vitalData.leftArmBP} disabled InputLabelProps={{ shrink: true }} />
                    </div>

                    <div className="answer col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                      <CustomTextField focused id="vital-dialog-right-bp" label="Right Arm" variant="outlined" helperText="High / Low" name="rightArmBP" value={vitalData.rightArmBP} disabled InputLabelProps={{ shrink: true }} />
                    </div>
                  </div>
                </div>
                <div className="pop-row">
                  <div className="label col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">Heart Rate</div>

                  <div className="vital-row col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                    <div className="answer col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                      <CustomTextField focused id="vital-dialog-heart-current" label="Current rate" variant="outlined" helperText="BPM" name="currentHeartRate" value={vitalData.currentHeartRate} disabled InputLabelProps={{ shrink: true }} inputProps={{ inputMode: "numeric" }} />
                    </div>

                    <div className="answer col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                      <CustomTextField focused id="vital-dialog-heart-resting" label="Resting rate" variant="outlined" helperText="BPM" name="restingHeartRate" value={vitalData.restingHeartRate} disabled InputLabelProps={{ shrink: true }} inputProps={{ inputMode: "numeric" }} />
                    </div>
                  </div>
                </div>
                <div className="pop-row">
                  <div className="pop-inner-row">
                    <div className="label col-5 col-sm-8 col-md-8 col-lg-6 col-xl-6">Body Temperature</div>

                    <div className="label col-5 col-sm-8 col-md-8 col-lg-6 col-xl-6">Blood Glucose</div>
                  </div>

                  <div className="vital-row col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                    <div className="answer col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                      <CustomTextField focused id="vital-dialog-body-temp" variant="outlined" helperText="Fahrenheit" name="bodyTemp" value={vitalData.bodyTemp} disabled inputProps={{ inputMode: "numeric" }} />
                    </div>

                    <div className="answer col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                      <CustomTextField focused id="vital-dialog-blood-sugar" variant="outlined" helperText="mmol/L" name="bloodSugar" value={vitalData.bloodSugar} disabled inputProps={{ inputMode: "numeric" }} />
                    </div>
                  </div>
                </div>
                <div className="pop-row">
                  <div className="label col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">Oxygen Level</div>

                  <div className="vital-row col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                    <div className="answer col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                      <CustomTextField focused id="vital-dialog-oxygen" variant="outlined" helperText="%" style={{ width: "100%" }} name="oxygenLevel" value={vitalData.oxygenLevel} disabled inputProps={{ inputMode: "numeric" }} />
                    </div>
                  </div>
                </div>
                <div className="pop-row" style={{ paddingBottom: "0px" }}>
                  <div className="label col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">Weight</div>

                  <div className="vital-row col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                    <div className="answer col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                      <CustomTextField focused id="vital-dialog-weight" variant="outlined" helperText="lbs" style={{ width: "100%" }} name="weight" value={vitalData.weight ?? ""} disabled inputProps={{ inputMode: "numeric" }} />
                    </div>
                  </div>
                </div>
              </MuiDialogContent>
              <div className="btn-div">
                <Button name="cancel" label="Close" className="caregiver-cancel-button" onClick={handleClose} />
              </div>
            </Dialog>
          </div>
        </div>
      </div>
    </>
  );
};

export default Vitals;
